import { onRequest, RequestMethod } from "common/axios/axios"
import { getApiUrl } from "common/axios/getApiUrl"
import { isSingleLoginApp } from "common/app"

export class UserRepository {
    // 로그인 화면
    // 로그인
    static onPostLogin = (params: any) => {
        const url = getApiUrl(isSingleLoginApp() ? 'login-single' : 'login');
        return onRequest({ url, method: RequestMethod.POST, params })
    }

    // 소셜 로그인
    static onPostSocialLogin = (params: any) => {
        const url = getApiUrl(isSingleLoginApp() ? 'social-login-single' : 'social-login');
        return onRequest({ url, method: RequestMethod.POST, params })
    }

    // 회원가입 화면
    // 회원가입
    static onPostSignup = (params: any) => {
        return onRequest({ url: getApiUrl('signup'), method: RequestMethod.POST, params })
    }

    // 가입 연령 정책 판정 — 생년월일 없이 호출하면 정책 적용 여부·본인인증 사용 여부만
    static onPostSignupPolicy = (params: { serviceId: string; birth?: string; countryCd?: string; ctnCountryCd?: string }) => {
        return onRequest({ url: getApiUrl('signup-policy'), method: RequestMethod.POST, params })
    }

    // 이메일 중복 체크
    static onGetCheckDuplicateEmail = (userId: string, serviceId: string) => {
        return onRequest({ url: getApiUrl('check-duplicate-input'), method: RequestMethod.GET, query: { userId, serviceId } })
    }

    // 이메일 중복 체크
    static onPostCheckDuplicateCtn = (params: any) => {
        return onRequest({ url: getApiUrl('check-duplicate-account'), method: RequestMethod.POST, params })
    }

    // 개인정보 이용 동의 약관 목록 조회 (searchTag로 화면별 분류 필터: 'sign_up' / 'withdraw' 등)
    static onGetTermsList = (locale: string, serviceId: string, searchTag?: string) => {
        return onRequest({
            url: getApiUrl('terms-list') + serviceId,
            method: RequestMethod.GET,
            query: { locale, ...(searchTag ? { searchTag } : {}) }
        })
    }

    // 약관 상세 조회
    static onGetTermsDetail = (termsId: string) => {
        return onRequest({ url: getApiUrl('terms-detail') + termsId, method: RequestMethod.GET})
    }

    // 회원탈퇴
    static onDeleteWithdraw = (params?: { reason?: string }) => {
        return onRequest({ url: getApiUrl('withdraw'), method: RequestMethod.DELETE, params })
    }

    // 아이디·비밀번호 찾기 — 본인인증 결과로 가입 계정 조회
    static onPostFindAccount = (params: any) => {
        return onRequest({ url: getApiUrl('find-account'), method: RequestMethod.POST, params })
    }

    // 비밀번호 재설정 — recoveryToken 사용
    static onPostResetPassword = (params: any) => {
        return onRequest({ url: getApiUrl('reset-password'), method: RequestMethod.POST, params })
    }

    // 인증 코드 생성 (SMS 발송)
    static onPostSendVerifyCode = (params: any) => {
        return onRequest({ url: getApiUrl('send-verify-code'), method: RequestMethod.POST, params })
    }

    // 인증 코드 검증
    static onPostCheckVerifyCode = (params: any) => {
        return onRequest({ url: getApiUrl('check-verify-code'), method: RequestMethod.POST, params })
    }

    // 다날 본인인증 OTP 발송 (포트원)
    static onPostPortOneSend = (params: any) => {
        return onRequest({ url: getApiUrl('portone-send'), method: RequestMethod.POST, params })
    }

    // 다날 본인인증 OTP 확인 (포트원)
    static onPostPortOneConfirm = (params: any) => {
        return onRequest({ url: getApiUrl('portone-confirm'), method: RequestMethod.POST, params })
    }
}
